module.exports = __webpack_public_path__ + "img/pic1.cabb8a10.png";